import { createRouter, createWebHistory } from "vue-router"
// import.meta.env.VITE_PUBLIC_PATH
import { isDev } from "@/utils/tools.js"
import useUserDataStore from "@/store/userDataStore"
import { jsBridge } from "@/utils/jsBridge.js"
import GlobalAudioPlayer from '@/components/media/audioPlayer/GlobalAudioPlayer.js'
import message from "@/components/functionCallComponent/message.jsx"
export const loginRoutes = []
export const noAuthenticationRoutes = []

export const isNoAuthenticatedToLogin = () => {
  const userDataStore = useUserDataStore()
  const regs = [...noAuthenticationRoutes, ...loginRoutes].map((item) => item?.split("/").pop().toLocaleLowerCase()).join("|")
  if (
    (window.location.pathname == "/" || !new RegExp(`(${regs})$`).test(window.location.pathname.split("/").pop().toLocaleLowerCase())) &&
    !userDataStore.isLogin
  ) {
    return true
  }
  return false
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      // 首页
      path: `/`,
      name: "home",
      component: () => import("@/page/home/home.vue"),
    },
    {
      // 天工
      path: `/skywork`,
      name: "skywork",
      component: () => import("@/page/skywork.vue"),
    },
    // {
    //   // 邀请码
    //   path: `/login`,
    //   name: "login",
    //   component: () => import("@/page/login_bf.vue"),
    // },
    {
      // 专题详情
      path: `/topic-detail`,
      name: "topicDetail",
      component: () => import("@/page/topicdetail/topicdetail.vue"),
    },

    {
      // 所有创作专题
      path: `/create-topics`,
      name: "createTopics",
      component: () => import("@/page/createTopics.vue"),
    },
    {
      // 作品投稿
      path: `/submit-topic`,
      name: "submitTopic",
      component: () => import("@/page/submitTopic.vue"),
    },
    {
      // 选择参考音乐
      path: `/select-refer-music`,
      name: "selectReferMusic",
      component: () => import("@/page/createSongs/selectReferMusic/selectReferMusic.vue"),
    },
    {
      // 我的作品
      path: `/my-work`,
      name: "myWork",
      component: () => import("@/page/myWork/myWork.vue"),
    },
    {
      // 创作歌曲
      path: `/create-songs`,
      name: "createSongs",
      component: () => import("@/page/createSongs/createSongs.vue"),
    },
    {
      // 描述音乐
      path: `/describe-music`,
      name: "describeMusic",
      component: () => import("@/page/describeMusic/describeMusic.vue"),
    },
    {
      // 分享落地页
      path: `/share-land`,
      name: "shareLand",
      component: () => import("@/page/landing/shareLanding.vue"),
    },
    {
      // 分享落地页
      path: `/shareLanding`,
      name: "shareLanding",
      component: () => import("@/page/landing/shareLanding.vue"),
    },
    {
      // 我的喜欢
      path: `/my-favorite`,
      name: "myFavorite",
      component: () => import("@/page/myFavorite/myFavorite.vue"),
    },
    {
      // 我的喜欢
      path: `/moon`,
      name: "moon",
      component: () => import("@/page/moon.vue"),
    },
    ...(isDev()
    ? [
        {
          // 测试组件页面
          path: `/test`,
          name: "test",
          component: () => import("@/page/test/test.vue"),
        },
        {
          // 测试组件页面
          path: `/test2`,
          name: "test2",
          component: () => import("@/page/test/test2.vue"),
        },
      ]
    : []),
  ],
})

// 在应用的状态中跟踪导航历史
export let navigationHistory = []

// 监听路由变化
router.beforeEach((to, from, next) => {
  message.clear();
  GlobalAudioPlayer.pause(GlobalAudioPlayer.currentUrl)
  to.meta.from = from.fullPath
  // 更新导航历史
  next()
})

// 在全局导航守卫中检查是否是最后一个页面
router.afterEach((to, from) => {
  // 检查是否是最后一个页面
  console.log("navigationHistory2", navigationHistory)
  if (to.path !== "/" && to.path !== "/skywork") {
    if (navigationHistory.length === 0 || to.path !== navigationHistory[navigationHistory.length - 1]) {
      navigationHistory.push(to.path)
    }
  }
  // if (navigationHistory.length === 0) {
  //   if (jsBridge.inTiangongApp) {
  //     jsBridge("view.close")
  //   }
  // }
  // if (to.path === from.path) {
  //   // 如果是后退导航，移除navigationHistory中的最后一项
  //   navigationHistory.pop()
  //   // console.log("navigationHistory", navigationHistory)
  // }
})

export default router
